<template>
  <v-card
    :width="newWidth"
    class="ma-3"
    :height="cardHeight"
    id="screenshots-card"
  >
    <div class="d-flex justify-space-between pr-4">
      <h3 class="py-3 pl-4">
        Screen Shots
      </h3>
      <h3 class="py-3 pl-4">
        {{ screenshotsCount }}
      </h3>
    </div>
    <div
      class="d-flex flex-wrap justify-center"
      style="overflow: auto; max-height:400px"
    >
      <v-card
        class="mb-3 mr-3 ml-3"
        style="max-height:400px; width:300px;"
        v-for="(screenshot, i) in data.screenshots.items"
        :key="i"
      >
        <v-img
          :src="screenshot.url"
          class="grey darken-4"
          style="max-height:300px;"
        ></v-img>
        <div
          class="d-flex justify-space-between align-center pl-3 pr-3 font-weight-bold"
          style="min-height: 40px"
        >
          <span>{{ screenshot.date }}</span>
          <span>{{ screenshot.time }}</span>
        </div>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import ScreenDetailData from '@/mixins/ScreenDetailData';
import card from '@/mixins/card';
import { MobileView } from '@/mixins';

export default {
  mixins: [ScreenDetailData, card, MobileView],
  computed: {
    screenshotsCount() {
      return `[${this.data.screenshots.items.length}]`;
    },
    newWidth() {
      if (this.showMobileView) {
        return this.cardWidth;
      }
      return '100%';
    },
  },
};
</script>

<style></style>
